import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetTenantDefaultRouteMutationVariables = Types.Exact<{
  input: Types.SetTenantDefaultRouteInput;
}>;


export type SetTenantDefaultRouteMutation = { __typename?: 'Mutation', setTenantDefaultRoute: { __typename?: 'TenantRouteConfigPayload', tenantRouteConfig?: { __typename?: 'TenantRouteConfigStateData', tenantId: string, route: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type TenantRouteConfigStateDataFragment = { __typename?: 'TenantRouteConfigStateData', tenantId: string, route: string };

export const TenantRouteConfigStateDataFragmentDoc = new TypedDocumentString(`
    fragment TenantRouteConfigStateData on TenantRouteConfigStateData {
  tenantId
  route
}
    `, {"fragmentName":"TenantRouteConfigStateData"});
export const SetTenantDefaultRouteDocument = new TypedDocumentString(`
    mutation SetTenantDefaultRoute($input: SetTenantDefaultRouteInput!) {
  setTenantDefaultRoute(input: $input) {
    tenantRouteConfig {
      ...TenantRouteConfigStateData
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantRouteConfigStateData on TenantRouteConfigStateData {
  tenantId
  route
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetTenantDefaultRoute: build.mutation<SetTenantDefaultRouteMutation, SetTenantDefaultRouteMutationVariables>({
      query: (variables) => ({ document: SetTenantDefaultRouteDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetTenantDefaultRouteMutation } = injectedRtkApi;
